export default __webpack_public_path__ + "static/media/uncheck_icon.9d053b29.svg";